<template lang="pug">
  ul.locale-switcher
    li.locale-switcher__item(
      v-for="locale in SUPPORTED_LOCALES"
      :key="locale"
      :class="{ 'locale-switcher__item_active': locale === currentLocale }"
      @click="switchLocale(locale)"
    )
      BaseImage.locale-switcher__image(:path="`${locale}.png`" :alt="$t(`language.${locale}`)" loading="eager")
      | {{ $t(`language.${locale}`) }}
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import BaseImage from '@/components/common/BaseImage.vue'
import { SUPPORTED_LOCALES, type SupportedLocale } from '@/config/locales'

const emit = defineEmits<{ switchLocale: [] }>()
const route = useRoute()
const router = useRouter()
const { locale } = useI18n()
const currentLocale = computed(() => locale.value)

const switchLocale = async (nextLocale: SupportedLocale): Promise<void> => {
  emit('switchLocale')
  if (nextLocale === locale.value) return

  await router.push({
    name: route.name ?? 'Index',
    params: { ...route.params, locale: nextLocale },
    query: route.query,
    hash: route.hash,
  })
}
</script>
